import { CreateModal } from '@/components/modals/live/create-modal'
import { Outlet, createFileRoute } from '@tanstack/react-router'


export const Route = createFileRoute('/_app/inventory/live/_modal')({
  component: RouteComponent,
})

function RouteComponent() {
  return <>
    <Outlet />
    <CreateModal />
  </>
} 
